import { formatDays } from "@/lib/format";
import type { LeaveDuration } from "@/features/leave/types";

/** "3 hours", "1 hour", "2.5 hours". The API sends hours as "3.00". */
export function hoursWords(value: string | number | null | undefined): string {
  const hours = Number(value);
  if (value === null || value === undefined || value === "" || Number.isNaN(hours)) return "—";
  return `${String(hours)} ${hours === 1 ? "hour" : "hours"}`;
}

/** "1 day", "2 days", "0.5 days". */
export function daysWords(value: string | number | null | undefined): string {
  const figure = formatDays(value);
  if (figure === "—") return figure;
  return `${figure} ${Number(value) === 1 ? "day" : "days"}`;
}

/**
 * How long a request is, said the way a person would.
 *
 * Unpaid leave may be taken by the hour or the half day, and "0.4" in a
 * column of days reads as a mistake when what somebody asked for was three
 * hours to move house.
 */
export function leaveLength(request: {
  duration?: LeaveDuration | null;
  hours?: string | null;
  days_requested: string;
}): string {
  if (request.duration === "hours" && request.hours) return hoursWords(request.hours);
  if (request.duration === "half_day") return "Half a day";
  return daysWords(request.days_requested);
}

/** Banked overtime said briefly: "7h 30m", "3h", "45m". */
export function overtimeWords(minutes: number | null | undefined): string {
  if (minutes === null || minutes === undefined || minutes <= 0) return "0h";
  const hours = Math.floor(minutes / 60);
  const rest = Math.round(minutes % 60);
  if (hours === 0) return `${rest}m`;
  return rest === 0 ? `${hours}h` : `${hours}h ${rest}m`;
}
